module.exports = __webpack_public_path__ + "img/ZArec4C_026-039-ZDRE02M0-front.ad7e2955.jpg";